import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getAllABorrowersLoans = async ({ borrower_id }) => {
  const data = await getData(
    `${ajaxEndpoints.ALL_LOANS_TIED_TO_A_BORROWER}?borrower_id=${borrower_id}`
  );
  return data;
};

export default function useAllAborrowersLoans({ borrower_id }) {
  return useQuery(
    [{ borrower_id }, "getAllABorrowersLoans"],
    getAllABorrowersLoans
  );
}
